import { useDeviceType } from "../hooks/useDeviceType";
import MobileLayout from "./MobileLayout/MobileLayout";
import TabletLayout from "./TabletLayout/TabletLayout";
import DesktopLayout from "./DesktopLayout/DesktopLayout";

export default function LayoutSwitcher({ children }) {
  const device = useDeviceType();

  if (device === "mobile") return <MobileLayout>{children}</MobileLayout>;
  if (device === "tablet") return <TabletLayout>{children}</TabletLayout>;
  return <DesktopLayout>{children}</DesktopLayout>;
}
